// Example uses styled-components, but styled-system works with most other css-in-js libraries as well
import React from 'react';
import styled from 'styled-components';
import {
  flexWrap,
  flexDirection,
  alignItems,
  justifyContent,
  alignContent,
  alignSelf,
  gridRowGap,
  gridColumnGap,
} from 'styled-system';

import Box from './Box';

// Add styled-system functions to your component
const Flex = styled(Box)`
  display: flex;
  ${flexWrap}
  ${flexDirection}
  ${alignItems}
  ${justifyContent}
  ${alignContent}
  ${alignSelf}
  ${gridRowGap}
  ${gridColumnGap}
`;

Flex.displayName = 'Flex';

Flex.propTypes = {
  ...flexWrap.propTypes,
  ...flexDirection.propTypes,
  ...alignItems.propTypes,
  ...justifyContent.propTypes,
};

export default Flex;
